export function ManualSignV3({
  basicInfo,
  userinfo,
  creditUser,
  firmaElectronica,
  dctoFirmaElectronica,
  total,
}) {
  const requests = [
    { id: 1, description: "Fotocopia cédula de ciudadanía." },
    /* { id: 2, description: "Certificado laboral no mayor a 30 días." }, */
    /* { id: 3, description: "Últimos 3 desprendibles de pago de nómina." }, */
    {
      id: 2,
      description: "Certificado de cuenta bancaria no mayor a 30 días.",
    },
    {
      id: 3,
      description:
        "Contrato de crédito y pagaré debidamente firmado, no es necesario firmar cada una de las páginas, con incorporar la firma en la página final es suficiente.",
    },
    /* {
      id: 6,
      description: "Pagaré y carta de instrucciones debidamente firmadas.",
    }, */
    /* {
      id: 7,
      description:
        "Documento de aceptación de los términos y condiciones generales del servicio debidamente firmado.",
    }, */
    /*     {
      id: 8,
      description:
        "Documento de aceptación de la Política de Privacidad y Tratamiento de datos debidamente firmado y autenticado ante Notaría.",
    }, */
  ];

  return (
    <>
      <div className="text-sm py-8 px-4">
        <div className="text-center w-full font-bold2">
          <div className="w-full">
            <div>
              GRUPO EMPRESARIAL ANAV S.A.S. –{" "}
              <span className="normal-case">(en adelante “Galilea”)</span>
            </div>
          </div>
        </div>
        <div className="pt-4">
          <div className="text-start w-full">
            Tu crédito queda en pendiente de Firma, para proceder con el
            desembolso recuerda que debes firmar los documentos de tu crédito.
            Una vez remitas todos los documentos indicados en el presente
            documento, Galilea se reserva el derecho a realizar la verificación
            de estos, este procedimiento puede tardar entre 3 a 5 días hábiles
            con posterioridad a la remisión de los documentos firmados de manera
            manuscrita.
          </div>
        </div>

        <div className="pt-4">
          <span className="font-bold2">
            Firma manuscrita - Proceso de firma física
          </span>
        </div>
        <div className="pt-4">
          <span >
            El Usuario de manera libre y voluntaria, de acuerdo con su libertad
            de escogencia contractual puede firmar de manera física los
            documentos del crédito. Razón por la cual, Galilea, ha dispuesto
            para el titular que no desee suscribir los documentos a través de la
            firma electrónica, un canal adicional para realizar la firma del
            crédito mediante el envío de la siguiente documentación a la
            dirección de correspondencia física Edificio Sibelius, Vereda Fagua, Sector La Caro Autopista Norte Chía, Cundinamarca,
            Bogotá, o a la dirección electrónica de manera escaneada al correo
            electrónico ayuda@galilea.co, si los documentos son enviados a la
            dirección física o electrónica deben estar autenticados por notaria.
            Los documentos que debe enviar el Usuario son:
          </span>
        </div>
        <div className="pt-4 px-4 pl-8">
          {requests.map((request, index) => (
            <ul className="pb-4" key={"ul-" + index}>
              <div className="text-sm" key={"div-" + index}>
                <li className="list-disc font-bold2" key={"li-" + index}>
                  {request.description}
                </li>
              </div>
            </ul>
          ))}
        </div>
        <div className="pt-4">
          <span >
            <span className="font-bold2">Recuerda: </span>
            No es necesario firmar todas las hojas, con que firmes la última
            página del Contrato y el pagaré es suficiente. El Usuario se obliga
            a suministrar información veraz, completa, actualizada y
            comprobable, así mismo, este deberá garantizar que a partir de los
            datos suministrados no busca inducir al error en los procesos
            internos, para lo cual, Galilea en procura de la veracidad realizará
            las rectificaciones respectivas siendo estas últimas de pleno
            conocimiento del Usuario.
          </span>
        </div>
        <div className="pt-4">
          <span className="font-bold2">
            Haz clic en el botón "Iniciar proceso" para que a tu correo lleguen
            todos los documentos que debes firmar.
          </span>
        </div>
      </div>
    </>
  );
}
